import { useState, useEffect, useRef } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { config, encodeBase64RequestBody, priceFormat, numberFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";
import { Modal } from "react-bootstrap";
import io from 'socket.io-client';
import { format } from "date-fns";

const OpportunityAdd = () => {
  const [ companies, setCompanies ] = useState(null);
  const [ company, setCompany ] = useState(null);
  const [ subcompanies, setSubcompanies ] = useState(null);
  const [ subcompany, setSubcompany ] = useState(null);
  const [ sourceName, setSourceName ] = useState(null);
  const [ opportunityTranscript, setOpportunityTranscript ] = useState([]);
  const [ opportunityEnquiry, setOpportunityEnquiry ] = useState('');
  const [ opportunityDealType, setOpportunityDealType ] = useState(null);
  const [ opportunityProductLine, setOpportunityProductLine ] = useState(null);
  const [ opportunityProductDetail, setOpportunityProductDetail ] = useState('');
  const [ opportunityProductMonths, setOpportunityProductMonths ] = useState(0);
  const [ opportunityExpectedClosed, setOpportunityExpectedClosed ] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [ opportunityExpectedRevenue, setOpportunityExpectedRevenue ] = useState(0);
  const [ opportunityExpectedProfit, setOpportunityExpectedProfit ] = useState(0);
  const [ opportunityRemarks, setOpportunityRemarks ] = useState('');
  const [ isLoadingSummarize, setIsLoadingSummarize ] = useState(false);
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);
  const [ isRecording, setIsRecording ] = useState(false);

  const [ companyName, setCompanyName ] = useState('');
  const [ companyBillingName, setCompanyBillingName ] = useState('');
  const [ companyDomain, setCompanyDomain ] = useState('');
  const [ companyModal, setCompanyModal ] = useState(false);
  const [ isLoadingCompanySubmit, setIsLoadingCompanySubmit ] = useState(false);
  
  const [ subcompanyName, setSubcompanyName ] = useState('');
  const [ subcompanyBillingName, setSubcompanyBillingName ] = useState('');
  const [ subcompanyAddress, setSubcompanyAddress ] = useState('');
  const [ subcompanyBillingAddress, setSubcompanyBillingAddress ] = useState('');
  const [ subcompanyPhone, setSubcompanyPhone ] = useState('');
  const [ subcompanyFax, setSubcompanyFax ] = useState('');
  const [ subcompanyNpwpNumber, setSubcompanyNpwpNumber ] = useState('');
  const [ subcompanyModal, setSubcompanyModal ] = useState(false);
  const [ isLoadingSubcompanySubmit, setIsLoadingSubcompanySubmit ] = useState(false);
  
  const navigate = useNavigate();

  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  const socketRef = useRef(null);
  const mediaRecorderRef = useRef(null);

  const dealTypeOptions = [
    { value: 'New Business', label: 'New Business' },
    { value: 'Cross Selling', label: 'Cross Selling' },
    { value: 'Exist Additional', label: 'Exist Additional' },
    { value: 'Renew Only', label: 'Renew Only' },
    { value: 'Upgrade', label: 'Upgrade' },
  ];

  const productLineOptions = [
    { label: 'GWS SMB', value: 'GWS SMB' },
    { label: 'GWS CORP', value: 'GWS CORP' },
    { label: 'GWS ENTERPRISE', value: 'GWS ENTERPRISE' },
    { label: 'CHROME ENTERPRISE', value: 'CHROME ENTERPRISE' },
    { label: 'CHROME EDUCATION', value: 'CHROME EDUCATION' },
    { label: 'HARDWARE', value: 'HARDWARE' },
    { label: 'EDUCATION LICENSES', value: 'EDUCATION LICENSES' },
    { label: 'TRAINING', value: 'TRAINING' },
    { label: 'SERVICES', value: 'SERVICES' },
    { label: 'MICROSOFT', value: 'MICROSOFT' },
    { label: 'GOOGLE CLOUD', value: 'GOOGLE CLOUD' },
    { label: 'GEMINI ENTERPRISE', value: 'GEMINI ENTERPRISE' },
    { label: 'APIGEE', value: 'APIGEE' },
    { label: 'LUMAPPS', value: 'LUMAPPS' },
    { label: 'JUMPCLOUD', value: 'JUMPCLOUD' },
    { label: 'OTHER LICENSES', value: 'OTHER LICENSES' },
    { label: 'CUSTOM APPS', value: 'CUSTOM APPS' },
    { label: 'KAMIGAWE LICENSES', value: 'KAMIGAWE LICENSES' },
    { label: 'KAMIGAWE SERVICES', value: 'KAMIGAWE SERVICES' },
    { label: 'SAAS APPS (ALBAN)', value: 'SAAS APPS (ALBAN)' }
  ];

  const sourceNameOptions = [
    { value: 'Personal', label: 'Personal' },
    { value: 'Principal', label: 'Principal' },
  ];

  useEffect(() => {
    const socketUrl = config.BASEURL.replace(/\/$/, '');
    socketRef.current = io(socketUrl, {
      transports: ['websocket', 'polling'],
      timeout: 20000,
      forceNew: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5,
      maxReconnectionAttempts: 5
    });
    
    socketRef.current.on('connect', () => {
      console.log('Socket.IO connected successfully with ID:', socketRef.current.id);
    });
    
    socketRef.current.on('connect_error', (error) => {
      console.error('Socket.IO connection error:', error);
    });
    
    socketRef.current.on('disconnect', (reason) => {
      console.log('Socket.IO disconnected:', reason);
    });
    
    socketRef.current.on('transcript', (data) => {
      if (data && data.transcript && data.transcript.trim()) {
        if (data.isFinal) {
          setOpportunityTranscript(prevTranscript => [...prevTranscript, data.transcript.trim()]);
        }
      }
    });

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
      if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
        mediaRecorderRef.current.stop();
      }
    };
  }, []);

  useEffect(() => {
    const getCompanies = async () => {
      try {
        const fetchCompanies = await jwtFetch(config.ENDPOINT + 'get/company', {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({})
        });
        const responseCompanies = await fetchCompanies.json();
        if (responseCompanies.status === 200) {
          const companies = [];
          for (let c in responseCompanies.data) {
            companies.push({
              value: responseCompanies.data[c].id_company,
              label: responseCompanies.data[c].company_name,
            });
          }
          setCompanies(companies);
        } else {
          console.log(responseCompanies.message);
        }
      } catch (error) {
        console.error('Error in getCompanies:', error);
        alert('An error occurred: ' + (error.message || error));
      }
    }
    getCompanies();
  }, []);

  useEffect(() => {
    if (company) {
      setSubcompany(null);
      const getSubcompanies = async () => {
        try {
          const fetchSubcompanies = await jwtFetch(config.ENDPOINT + 'get/subcompany', {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
            },
            body: encodeBase64RequestBody({
              "company_id": company.value,
            })
          });
          const responseSubcompanies = await fetchSubcompanies.json();
          if (responseSubcompanies.status === 200) {
            const subcompanies = [];
            for (let s in responseSubcompanies.data) {
              subcompanies.push({
                value: responseSubcompanies.data[s].id_subcompany,
                label: responseSubcompanies.data[s].company_name,
              });
            }
            setSubcompanies(subcompanies);
          } else {
            console.log(responseSubcompanies.message);
          }
        } catch (error) {
          console.error('Error in getSubcompanies:', error);
          alert('An error occurred: ' + (error.message || error));
        }
      }
      getSubcompanies();
    }
  }, [company]);

  const startStopRecording = async () => {
    if (isRecording) {
      if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
        mediaRecorderRef.current.stop();
      }
      if (socketRef.current) {
        socketRef.current.emit('stop-stream');
      }
    } else {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        mediaRecorderRef.current = new MediaRecorder(stream, {
          mimeType: 'audio/webm;codecs=opus',
        });

        mediaRecorderRef.current.ondataavailable = (event) => {
          if (event.data.size > 0 && socketRef.current) {
            socketRef.current.emit('audio-stream', event.data);
          }
        };
        socketRef.current.emit('start-stream');
        mediaRecorderRef.current.start(500);        
      } catch (error) {
        console.error('Error accessing microphone:', error);
      }
    }
    setIsRecording(!isRecording);
  };

  const summarizeRecording = async () => {
    setIsLoadingSummarize(true);
    try {
      const requestSummarizeRecording = {
        "inputData": JSON.stringify(opportunityTranscript),
        "userKeyId": crmUser.user_keyid,
      };
      const fetchSummarizeRecording = await jwtFetch(config.ENDPOINT + 'summarize/lead', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestSummarizeRecording)
      });
      const responseSummarizeRecording = await fetchSummarizeRecording.json();
      if (responseSummarizeRecording.status === 200) {
        setOpportunityEnquiry(responseSummarizeRecording.data);
      } else {
        console.log(responseSummarizeRecording.message);
      }
    } catch (error) {
      console.log('Error summarizing recording: ' + error.message);
    }
    setIsLoadingSummarize(false);
  }
  
  const closeCompanyModal = () => {
    setCompanyModal(false);
    setCompanyName('');
    setCompanyBillingName('');
    setCompanyDomain('');
  };

  const closeSubcompanyModal = () => {
    setSubcompanyModal(false);
    setSubcompanyName('');
    setSubcompanyBillingName('');
    setSubcompanyAddress('');
    setSubcompanyBillingAddress('');
    setSubcompanyPhone('');
    setSubcompanyFax('');
    setSubcompanyNpwpNumber('');
  };

  const addCompany = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingCompanySubmit(true);
      const crmUser = JSON.parse(localStorage.getItem('crmUser'));

      const requestCompanyAdd = {
        "company_name": companyName,
        "company_domain": companyDomain,
        "company_billing_name": companyBillingName,
        "company_status": 'Active',
        "created_on": format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        "created_by": crmUser.user_keyid,
      }

      const fetchCompanyAdd = await jwtFetch(config.ENDPOINT + 'create/company', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestCompanyAdd)
      });
      const responseCompanyAdd = await fetchCompanyAdd.json();
      if (responseCompanyAdd.status === 200) {
        const newCompany = {
          value: responseCompanyAdd.data.insertId,
          label: companyName
        };
        setCompanies(prevCompanies => [...prevCompanies, newCompany]);
        setCompany(newCompany);
        closeCompanyModal();
      } else {
        alert(responseCompanyAdd.message);
      }
      setIsLoadingCompanySubmit(false);
    } catch (error) {
      console.error('Error in addCompany:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingCompanySubmit(false);
    }
  };

  const addSubcompany = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubcompanySubmit(true);
      const crmUser = JSON.parse(localStorage.getItem('crmUser'));

      const requestSubcompanyAdd = {
        "company_id": company ? company.value : null,
        "company_name": subcompanyName,
        "company_billing_name": subcompanyBillingName,
        "company_address": subcompanyAddress,
        "company_billing_address": subcompanyBillingAddress,
        "company_phone": subcompanyPhone,
        "company_fax": subcompanyFax,
        "company_npwp_number": subcompanyNpwpNumber,
        "company_status": 'Active',
        "created_on": format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        "created_by": crmUser.user_keyid,
      }

      const fetchSubcompanyAdd = await jwtFetch(config.ENDPOINT + 'create/subcompany', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestSubcompanyAdd)
      });
      const responseSubcompanyAdd = await fetchSubcompanyAdd.json();
      if (responseSubcompanyAdd.status === 200) {
        const newSubcompany = {
          value: responseSubcompanyAdd.data.id_subcompany,
          label: subcompanyName
        };
        setSubcompanies(prevSubcompanies => [...(prevSubcompanies || []), newSubcompany]);
        setSubcompany(newSubcompany);
        closeSubcompanyModal();
      } else {
        alert(responseSubcompanyAdd.message);
      }
      setIsLoadingSubcompanySubmit(false);
    } catch (error) {
      console.error('Error in addSubcompany:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubcompanySubmit(false);
    }
  };

  const addOpportunity = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);

      const requestOpportunityAdd = {
        "company_id": company.value,
        "subcompany_id": subcompany.value,
        "opportunity_source": sourceName ? sourceName.value : null,
        "opportunity_enquiry": opportunityEnquiry,
        "opportunity_open_for": 0,
        "opportunity_expected_closed": opportunityExpectedClosed,
        "opportunity_deal_type": opportunityDealType ? opportunityDealType.value : null,
        "opportunity_product_line": opportunityProductLine ? opportunityProductLine.value : null,
        "opportunity_product_detail": opportunityProductDetail,
        "opportunity_product_months": opportunityProductMonths,
        "opportunity_expected_revenue": opportunityExpectedRevenue,
        "opportunity_expected_profit": opportunityExpectedProfit,
        "opportunity_remarks": opportunityRemarks,
        "opportunity_status": 'Open',
        "assigned_to": crmUser.user_keyid,
        "created_on": format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
        "created_by": crmUser.user_keyid,
      }

      const fetchOpportunityAdd = await jwtFetch(config.ENDPOINT + 'create/opportunity_lead', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestOpportunityAdd)
      });
      const responseOpportunityAdd = await fetchOpportunityAdd.json();
      if (responseOpportunityAdd.status === 200) {
        window.location.href = '/opportunity';
      } else {
        console.log(responseOpportunityAdd.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in addOpportunity:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  return (
    <div id="opportunity-add">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="opportunity"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="fs-24"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left"/></button> Opportunity Add</div>
                  </div>
                  <form onSubmit={(e) => addOpportunity(e)}>
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <div className="row form-group align-items-center mb-2">
                          <div className="col-md-4">
                            <label>Company Group <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <div className="row align-items-center">
                              <div className="col-md-10">
                                <Select options={companies} value={company} onChange={(value) => setCompany(value)} required/>
                              </div>
                              <div className="col-md-2 text-end">
                                <button className="btn btn-outline-secondary btn-sm" type="button" onClick={() => setCompanyModal(true)}>
                                  <i className="bi bi-plus-lg"/>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row form-group align-items-center mb-2">
                          <div className="col-md-4">
                            <label>Subsidiary <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <div className="row align-items-center">
                              <div className="col-md-10">
                                <Select options={subcompanies} value={subcompany} onChange={(value) => setSubcompany(value)} isDisabled={!company && !subcompanies} required/>
                              </div>
                              <div className="col-md-2 text-end">
                                <button className="btn btn-outline-secondary btn-sm" type="button" onClick={() => setSubcompanyModal(true)} disabled={!company}>
                                  <i className="bi bi-plus-lg"/>
                                </button>
                              </div>
                            </div>                              
                          </div>
                        </div>
                        <div className="row form-group align-items-center mb-2">
                          <div className="col-md-4">
                            <label>Enquiry <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <textarea className="form-control" value={opportunityEnquiry} onChange={(e) => setOpportunityEnquiry(e.target.value)} required/>
                          </div>
                        </div>
                        <div className="row form-group align-items-center mb-2">
                          <div className="col-md-4">
                            <label>Source <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <Select options={sourceNameOptions} value={sourceName} placeholder="" onChange={(value) => setSourceName(value)} required/>
                          </div>
                        </div>
                        <div className="row align-items-baseline form-group mb-2">
                          <div className="col-md-4">
                            <label>Product Line <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <Select options={productLineOptions} value={opportunityProductLine} onChange={(value) => setOpportunityProductLine(value)} />
                          </div>
                        </div>
                        <div className="row align-items-baseline form-group mb-2">
                          <div className="col-md-4">
                            <label>Product Details <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <textarea className="form-control" rows="4" value={opportunityProductDetail} onChange={(e) => setOpportunityProductDetail(e.target.value)} />
                          </div>
                        </div>
                        <div className="row align-items-baseline form-group mb-2">
                          <div className="col-md-4">
                            <label>Deal Type <span className="text-danger">*</span></label>
                          </div>
                          <div className="col-md-8">
                            <Select options={dealTypeOptions} value={opportunityDealType} onChange={(value) => setOpportunityDealType(value)} />
                          </div>
                        </div>
                        <div className="row form-group align-items-center mb-2">
                          <div className="col-md-4">
                            <label>Remarks</label>
                          </div>
                          <div className="col-md-8">
                            <textarea className="form-control" rows="4" value={opportunityRemarks} onChange={(e) => setOpportunityRemarks(e.target.value)} />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card mb-2">
                          <div className="card-body border-0">
                            <div className="fs-18 mb-3">Voice Reader</div>
                            <div>
                              {opportunityTranscript.length > 0 ? (
                                <div className="record-box mb-2">
                                  {opportunityTranscript.map((sentence, index) => (
                                    <p className="mb-1" key={index}>{sentence}</p>
                                  ))}
                                </div>
                              ) : (
                                <p>Click 'Record' and start speaking...</p>
                              )}
                            </div>
                            <div className="d-flex justify-content-end">
                              <button className={"btn ms-2 " + (isRecording ? 'bg-danger text-light' : 'bg-gold')} type="button" onClick={startStopRecording}>{isRecording ? (<span><i className="bi bi-square-fill me-1"/> Stop</span>) : (<span><i className="bi bi-square me-1"/> Record</span>)}</button>
                              {opportunityTranscript.length > 0 && (
                                <button className="btn bg-gold ms-2" type="button" onClick={() => summarizeRecording()} disabled={isLoadingSummarize}>{isLoadingSummarize ? "Loading..." : (<span><i className="bi bi-stars me-1"/> Summarize</span>)}</button>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="card mb-2">
                          <div className="card-body">
                            <div className="row form-group align-items-center mb-2">
                              <div className="col-md-4">
                                <label>Months <span className="text-danger">*</span></label>
                              </div>
                              <div className="col-md-8">
                                <input className="form-control text-end" type="number" value={opportunityProductMonths} onChange={(e) => setOpportunityProductMonths(numberFormat(e.target.value))}/>
                              </div>
                            </div>
                            <div className="row form-group align-items-center">
                              <div className="col-md-4">
                                <label>Expected Closing Date <span className="text-danger">*</span></label>
                              </div>
                              <div className="col-md-8">
                                <input className="form-control" type="date" value={opportunityExpectedClosed} onChange={(e) => setOpportunityExpectedClosed(e.target.value)}/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card mb-2">
                          <div className="card-body">
                            <div className="row form-group align-items-center mb-2">
                              <div className="col-md-4">
                                <label>Estimated Revenue <span className="text-danger">*</span></label>
                              </div>
                              <div className="col-md-8">
                                <div className="input-group">
                                  <input className="form-control text-end" type="text" value={priceFormat(opportunityExpectedRevenue)} onChange={(e) => setOpportunityExpectedRevenue(numberFormat(e.target.value))}/>
                                  <span className="input-group-text mw-85">IDR</span>
                                </div>
                              </div>
                            </div>
                            <div className="row form-group align-items-center">
                              <div className="col-md-4">
                                <label>Estimated Profit <span className="text-danger">*</span></label>
                              </div>
                              <div className="col-md-8">
                                <div className="input-group">
                                  <input className="form-control text-end" type="text" value={priceFormat(opportunityExpectedProfit)} onChange={(e) => setOpportunityExpectedProfit(numberFormat(e.target.value))}/>
                                  <span className="input-group-text mw-85">IDR</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end">
                        <button className="btn btn-link" type="button" onClick={() => window.location.href = "/lead"}>Cancel</button>
                        <button className="btn bg-gold ms-2" type="submit">{isLoadingSubmit ? 'Loading...' : 'Save'}</button>
                      </div>
                    </div>
                  </form>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Modal show={companyModal} onHide={() => closeCompanyModal()}>
        <Modal.Header closeButton>
          <Modal.Title>Company Group Add</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={(e) => addCompany(e)}>
            <div className="border border-1 border-radius-3 p-4 mb-3">
              <div className="row form-group align-items-center mb-2">
                <div className="col-md-4">
                  <label>Group Name <span className="text-danger">*</span></label>
                </div>
                <div className="col-md-8">
                  <input className="form-control" type="text" value={companyName} onChange={(e) => setCompanyName(e.target.value)} required />
                </div>
              </div>
              <div className="row form-group align-items-center mb-2">
                <div className="col-md-4">
                  <label>Legal Name <span className="text-danger">*</span></label>
                </div>
                <div className="col-md-8">
                  <input className="form-control" type="text" value={companyBillingName} onChange={(e) => setCompanyBillingName(e.target.value)} required />
                </div>
              </div>
              <div className="row form-group align-items-center mb-2">
                <div className="col-md-4">
                  <label>Domain</label>
                </div>
                <div className="col-md-8">
                  <input className="form-control" type="text" value={companyDomain} onChange={(e) => setCompanyDomain(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button className="btn btn-link" type="button" onClick={() => closeCompanyModal()}>Cancel</button>
              <button className="btn bg-gold ms-2" type="submit" disabled={isLoadingCompanySubmit}>{isLoadingCompanySubmit ? 'Loading...' : 'Save'}</button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal show={subcompanyModal} onHide={() => closeSubcompanyModal()}>
        <Modal.Header closeButton>
          <Modal.Title>Subsidiary Add</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={(e) => addSubcompany(e)}>
            <div className="border border-1 border-radius-3 p-4 mb-3">
              <div className="row form-group align-items-center mb-2">
                <div className="col-md-4">
                  <label>Company Name <span className="text-danger">*</span></label>
                </div>
                <div className="col-md-8">
                  <input className="form-control" type="text" value={subcompanyName} onChange={(e) => setSubcompanyName(e.target.value)} required />
                </div>
              </div>
              <div className="row form-group align-items-center mb-2">
                <div className="col-md-4">
                  <label>Legal Name <span className="text-danger">*</span></label>
                </div>
                <div className="col-md-8">
                  <input className="form-control" type="text" value={subcompanyBillingName} onChange={(e) => setSubcompanyBillingName(e.target.value)} required />
                </div>
              </div>
              <div className="row form-group align-items-center mb-2">
                <div className="col-md-4">
                  <label>Billing Address</label>
                </div>
                <div className="col-md-8">
                  <textarea className="form-control" rows="3" value={subcompanyBillingAddress} onChange={(e) => setSubcompanyBillingAddress(e.target.value)} />
                </div>
              </div>
              <div className="row form-group align-items-center mb-2">
                <div className="col-md-4">
                  <label>Mailing Address</label>
                </div>
                <div className="col-md-8">
                  <textarea className="form-control" rows="3" value={subcompanyAddress} onChange={(e) => setSubcompanyAddress(e.target.value)} />
                </div>
              </div>
              <div className="row form-group align-items-center mb-2">
                <div className="col-md-4">
                  <label>Phone Number</label>
                </div>
                <div className="col-md-8">
                  <input className="form-control" type="text" value={subcompanyPhone} onChange={(e) => setSubcompanyPhone(e.target.value)} />
                </div>
              </div>
              <div className="row form-group align-items-center mb-2">
                <div className="col-md-4">
                  <label>Fax</label>
                </div>
                <div className="col-md-8">
                  <input className="form-control" type="text" value={subcompanyFax} onChange={(e) => setSubcompanyFax(e.target.value)} />
                </div>
              </div>
              <div className="row form-group align-items-center mb-2">
                <div className="col-md-4">
                  <label>NPWP Number</label>
                </div>
                <div className="col-md-8">
                  <input className="form-control" type="text" value={subcompanyNpwpNumber} onChange={(e) => setSubcompanyNpwpNumber(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button className="btn btn-link" type="button" onClick={() => closeSubcompanyModal()}>Cancel</button>
              <button className="btn bg-gold ms-2" type="submit" disabled={isLoadingSubcompanySubmit}>{isLoadingSubcompanySubmit ? 'Loading...' : 'Save'}</button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default OpportunityAdd;


